import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Box, Button, Flex, Heading, CircularProgress, FormControl, FormLabel, Input, HStack, RadioGroup, Radio, Textarea, Text, Alert, FormErrorMessage, } from '@chakra-ui/react'
import Layout from '../layout'
import { Field, Formik, useFormikContext } from 'formik'
import { FormValidator } from '../utils/validationForms'
import { storeReclamo } from "../actions"

const ScrollToError = () => {
    const { errors, submitCount } = useFormikContext();
    useEffect(() => {
        if (submitCount > 0 && Object.keys(errors).length > 0) {

            const firstErrorKey = Object.keys(errors)[0];
            const errorElement = document.getElementById(firstErrorKey);

            if (errorElement) {
                errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    }, [errors, submitCount]);
    return null;
}

const Reclamos = (props) => {

    const dispatch = useDispatch()

    const [alert, showAlert] = useState(false);

    return (
        <Layout>

            <Heading textAlign={"center"} size={"2xl"}>HOJA DE RECLAMACIÓN</Heading>
            <Heading textAlign={"center"} size={"xl"}>INVERSIONES FUTURO, LTDA. DE C.V.</Heading>
            <Heading textAlign={"center"} size={"xl"}>NIT: 0614-180521-101-0</Heading>

            <Flex maxW={"1400px"} flexDir={'column'} p={4} m={"auto"} mt={"2rem"} mb={"2rem"}>


                {alert ?
                    <Alert status='success' textColor={"#000"} variant='left-accent' maxW={"800px"} textAlign={"center"} margin={"auto"}>
                        <p>
                            Estimado/a cliente:
                            <br />
                            Le informamos que su mensaje ha sido registrado y será evaluado por nuestro equipo correspondiente, quien se pondrá en contacto con usted a la brevedad posible para brindarle una respuesta o solución adecuada, conforme a nuestros procedimientos internos y la normativa vigente.
                            <br />
                            En EasyCar valoramos su confianza y agradecemos que nos ayude a mejorar nuestro servicio.
                            <br />
                            Responderemos su reclamo / queja por escrito en un plazo máximo de <b>15 (QUINCE) días hábiles</b>, contados desde el día siguiente a la recepción del mismo.
                            <br />
                            Para más información puede comunicarse al área de quejas y reclamos: whatsapp: <b>7507-1617</b>
                            <br /><br />
                            Atentamente, <br />
                            Equipo EasyCar
                        </p>
                    </Alert>
                    :

                    <Box bgColor={"#005fab"} textColor={"#FFF"} rounded={6} padding={10}>
                        <Formik
                            initialValues={{
                                nombre: '',
                                edad: 0,
                                direccion: '',
                                municipio: '',
                                departamento: '',
                                dni: '',
                                telefono: '',
                                celular: '',
                                email: '',
                                padre_name: '',
                                tipo: '',
                                tipo2: '',
                                monto: 0,
                                producto: '',
                                credito: '',
                                detalle: '',
                                envio: '',
                                certificado: '',
                                file: null,
                                filereclamo1: null,
                                filereclamo2: null,
                            }}
                            validate={values => FormValidator([
                                { field: 'nombre', value: values.nombre, rules: ['required'], lang: 'Nombre' },
                                { field: 'direccion', value: values.direccion, rules: ['required'], lang: 'Domicilio' },
                                { field: 'dni', value: values.dni, rules: ['required'], lang: 'DPI' },
                                { field: 'celular', value: values.celular, rules: ['required'], lang: 'Celular' },
                                { field: 'email', value: values.email, rules: ['required'], lang: 'Correo electrónico' },
                                { field: 'tipo', value: values.tipo, rules: ['required'], lang: 'Tipo de servicio' },
                                { field: 'producto', value: values.producto, rules: ['required'], lang: 'Producto contratado' },
                                { field: 'tipo2', value: values.tipo2, rules: ['required'], lang: 'Tipo' },
                                { field: 'file', value: values.file, rules: ['maxSize'], lang: 'Detalle' },
                                { field: 'filereclamo1', value: values.filereclamo1, rules: ['maxSize'], lang: 'Fotografía del tablero' },
                                { field: 'filereclamo2', value: values.filereclamo2, rules: ['maxSize'], lang: 'Fotografía de certificado de garantía' }
                            ])}

                            onSubmit={(values, { setSubmitting, resetForm }) => {
                                setSubmitting(true);

                                const formData = new FormData()
                                for (let value in values) {
                                    formData.append(value, values[value])
                                }

                                Promise.resolve(dispatch(storeReclamo(formData)))
                                    .then(() => {
                                        setSubmitting(false);
                                        showAlert(true);
                                        window.scrollTo(0, 0);
                                        resetForm();
                                    })
                                    .catch(() => {
                                        setSubmitting(false);
                                    });

                            }}

                        >
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <ScrollToError />

                                    <br />
                                    <legend>Detalle de la Reclamación/Queja /Pedido</legend>
                                    <br />

                                    <HStack>
                                        <FormControl isInvalid={errors.tipo2 && touched.tipo2}>
                                            <FormLabel>Tipo: <span style={{ color: 'red' }}>*</span></FormLabel>
                                            <RadioGroup id='tipo2' value={values.tipo2} onChange={handleChange} spacing='24px' name="tipo2">
                                                <Field colorScheme="easycar1" as={Radio} value={"RECLAMO"} >
                                                    RECLAMO (Disconformidad relacionada a los productos o servicios)
                                                </Field>
                                                <br />
                                                <Field colorScheme="easycar1" as={Radio} value={"QUEJA"} >
                                                    QUEJA (Disconformidad no relacionada a los productos o servicios; o malestar respecto a la atención al público)
                                                </Field>
                                                <br />
                                                <Field colorScheme="easycar1" as={Radio} value={"PEDIDO"} >
                                                    PEDIDO
                                                </Field>

                                            </RadioGroup>
                                            <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.tipo2}</FormErrorMessage> </Box>

                                        </FormControl>
                                    </HStack>
                                    <br />

                                    <legend>1. Identificación del Consumidor Reclamante</legend>
                                    <br />
                                    <HStack>
                                        <FormControl isInvalid={errors.nombre && touched.nombre}>
                                            <FormLabel>Nombre <span style={{ color: 'red' }}>*</span></FormLabel>
                                            <Input id='nombre' textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"nombre"} onChange={handleChange} onBlur={handleBlur} value={values.nombre} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }} maxlength="200" />
                                            <Box minHeight="50px" > <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.nombre}</FormErrorMessage> </Box>
                                        </FormControl>

                                        <FormControl isInvalid={errors.edad && touched.edad}>
                                            <FormLabel>Edad</FormLabel>
                                            <Input id='edad' textColor={"blackAlpha.900"} variant={"filled"} type={'number'} size="lg" name={"edad"} min={0} max={100} onChange={handleChange} onBlur={handleBlur} value={values.edad} step={1} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }} />
                                            <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.edad}</FormErrorMessage> </Box>
                                        </FormControl>
                                    </HStack>

                                    <HStack>
                                        <FormControl isInvalid={errors.direccion && touched.direccion}>
                                            <FormLabel>Domicilio <span style={{ color: 'red' }}>*</span></FormLabel>
                                            <Input id='direccion' textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"direccion"} onChange={handleChange} onBlur={handleBlur} value={values.direccion} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="400" />
                                            <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.direccion}</FormErrorMessage> </Box>
                                        </FormControl>
                                    </HStack>
                                    <br />

                                    <HStack>
                                        <FormControl isInvalid={errors.municipio && touched.municipio}>
                                            <FormLabel>Municipio</FormLabel>
                                            <Input id='municipio' textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"municipio"} onChange={handleChange} onBlur={handleBlur} value={values.municipio} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="220" />
                                            <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.municipio}</FormErrorMessage> </Box>
                                        </FormControl>

                                        <FormControl isInvalid={errors.departamento && touched.departamento}>
                                            <FormLabel>Departamento</FormLabel>
                                            <Input id='departamento' textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"departamento"} onChange={handleChange} onBlur={handleBlur} value={values.departamento} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="220" />
                                            <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.departamento}</FormErrorMessage> </Box>
                                        </FormControl>
                                    </HStack>
                                    <br />

                                    <HStack>
                                        <FormControl isInvalid={errors.dni && touched.dni}>
                                            <FormLabel>Documento Único de identidad (DUI) <span style={{ color: 'red' }}>*</span></FormLabel>
                                            <Input id='dni' textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"dni"} onChange={handleChange} onBlur={handleBlur} value={values.dni} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="25"/>
                                            <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.dni}</FormErrorMessage> </Box>
                                        </FormControl>
                                    </HStack>
                                    <br />

                                    <HStack>
                                        <FormControl isInvalid={errors.telefono && touched.telefono}>
                                            <FormLabel>Número de Teléfono Fijo:</FormLabel>
                                            <Input textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"telefono"} onChange={handleChange} onBlur={handleBlur} value={values.telefono} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="25" />
                                            <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.telefono}</FormErrorMessage> </Box>

                                        </FormControl>

                                        <FormControl isInvalid={errors.celular && touched.celular}>
                                            <FormLabel>Celular <span style={{ color: 'red' }}>*</span></FormLabel>
                                            <Input id='celular' textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"celular"} onChange={handleChange} onBlur={handleBlur} value={values.celular} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="25" />
                                            <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.celular}</FormErrorMessage> </Box>
                                        </FormControl>
                                    </HStack>
                                    <br />

                                    <HStack>
                                        <FormControl isInvalid={errors.email && touched.email}>
                                            <FormLabel>Correo electrónico <span style={{ color: 'red' }}>*</span></FormLabel>
                                            <Input id='email' textColor={"blackAlpha.900"} variant={"filled"} type={'email'} size="lg" name={"email"} onChange={handleChange} onBlur={handleBlur} value={values.email} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="200" />
                                            <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.email}</FormErrorMessage> </Box>
                                        </FormControl>
                                    </HStack>
                                    <br />
                                    <legend>Padre o Madre o Representante (en caso de menores de edad u otros):</legend>
                                    <HStack>
                                        <FormControl isInvalid={errors.padre_name && touched.padre_name}>
                                            <FormLabel>Nombre Completo</FormLabel>
                                            <Input textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"padre_name"} onChange={handleChange} onBlur={handleBlur} value={values.padre_name} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="200" />
                                        </FormControl>
                                    </HStack>
                                    <br />
                                    <br />

                                    {values.tipo2 === "RECLAMO" ?

                                        <>

                                            <legend>2. Identificación del servicio Contratado</legend>
                                            <br />

                                            <HStack>
                                                <FormControl isInvalid={errors.tipo && touched.tipo}>
                                                    <FormLabel>Tipo de servicio: (Crédito de consumo/otro) <span style={{ color: 'red' }}>*</span></FormLabel>
                                                    <Input id='tipo' textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"tipo"} onChange={handleChange} onBlur={handleBlur} value={values.tipo} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="200" />
                                                    <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.tipo}</FormErrorMessage> </Box>

                                                </FormControl>
                                            </HStack>
                                            <br />

                                            <HStack>
                                                <FormControl isInvalid={errors.producto && touched.producto}>
                                                    <FormLabel>Producto contratado: <span style={{ color: 'red' }}>*</span></FormLabel>
                                                    <Input id='producto' textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"producto"} onChange={handleChange} onBlur={handleBlur} value={values.producto} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="200" />
                                                    <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.producto}</FormErrorMessage> </Box>
                                                </FormControl>
                                            </HStack>
                                            <br />

                                            <HStack>
                                                <FormControl isInvalid={errors.credito && touched.credito}>
                                                    <FormLabel>N° de Crédito: </FormLabel>
                                                    <Input textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"credito"} onChange={handleChange} onBlur={handleBlur} value={values.credito} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="200" />
                                                    <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.credito}</FormErrorMessage> </Box>

                                                </FormControl>
                                            </HStack>
                                            <br />

                                            <HStack>
                                                <FormControl isInvalid={errors.monto && touched.monto}>
                                                    <FormLabel>Monto en dólares reclamado:</FormLabel>
                                                    <Input textColor={"blackAlpha.900"} variant={"filled"} type={'number'} size="lg" name={"monto"} min={0} step={0.01} onChange={handleChange} onBlur={handleBlur} value={values.monto} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }} />
                                                    <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.monto}</FormErrorMessage> </Box>

                                                </FormControl>
                                            </HStack>
                                            <br />


                                            <HStack>
                                                <FormControl isInvalid={errors.filereclamo1 && touched.filereclamo1}>
                                                    <FormLabel>Adjuntar fotografía del tablero actual (millaje / km) (PNG, JPG, PDF con un máximo de 5MB ):</FormLabel>
                                                    <Input
                                                        textColor={"blackAlpha.900"}
                                                        accept="image/*,application/pdf"
                                                        variant={"filled"}
                                                        type={'file'}
                                                        size="lg"
                                                        name={"filereclamo1"}
                                                        onChange={(event) =>
                                                            setFieldValue("filereclamo1", event.currentTarget.files[0])
                                                        }
                                                    />
                                                    <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.filereclamo1}</FormErrorMessage> </Box>
                                                </FormControl>

                                            </HStack>

                                            <br /><br />

                                            <HStack>
                                                <FormControl isInvalid={errors.certificado && touched.certificado}>
                                                    <FormLabel>Cuenta con certificado de garantía</FormLabel>
                                                    <RadioGroup id='certificado' value={values.certificado} onChange={handleChange} spacing='24px' name="certificado">
                                                        <Field colorScheme="easycar1" as={Radio} value={"SI"} >
                                                            Si
                                                        </Field>
                                                        <br />
                                                        <Field colorScheme="easycar1" as={Radio} value={"NO"} >
                                                            No
                                                        </Field>
                                                    </RadioGroup>

                                                </FormControl>
                                            </HStack>

                                            <br />

                                            <HStack>
                                                <FormControl isInvalid={errors.filereclamo2 && touched.filereclamo2}>
                                                    <FormLabel>Adjuntar fotografía certificado de garantía (PNG, JPG, PDF con un máximo de 5MB ):</FormLabel>
                                                    <Input
                                                        textColor={"blackAlpha.900"}
                                                        accept="image/*,application/pdf"
                                                        variant={"filled"}
                                                        type={'file'}
                                                        size="lg"
                                                        name={"filereclamo2"}
                                                        onChange={(event) =>
                                                            setFieldValue("filereclamo2", event.currentTarget.files[0])
                                                        }
                                                    />
                                                    <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.filereclamo2}</FormErrorMessage> </Box>
                                                </FormControl>

                                            </HStack>

                                            <br /><br />
                                        </>

                                        : values.tipo2 === "QUEJA" ?

                                            <>

                                                <legend>2. Identificación del servicio Contratado</legend>
                                                <br />

                                                <HStack>
                                                    <FormControl isInvalid={errors.tipo && touched.tipo}>
                                                        <FormLabel>Tipo de servicio: (Crédito de consumo/otro) <span style={{ color: 'red' }}>*</span></FormLabel>
                                                        <Input id='tipo' textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"tipo"} onChange={handleChange} onBlur={handleBlur} value={values.tipo} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="200" />
                                                        <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.tipo}</FormErrorMessage> </Box>

                                                    </FormControl>
                                                </HStack>
                                                <br />

                                                <HStack>
                                                    <FormControl isInvalid={errors.producto && touched.producto}>
                                                        <FormLabel>Producto contratado: <span style={{ color: 'red' }}>*</span></FormLabel>
                                                        <Input id='producto' textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"producto"} onChange={handleChange} onBlur={handleBlur} value={values.producto} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="200" />
                                                        <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.producto}</FormErrorMessage> </Box>
                                                    </FormControl>
                                                </HStack>
                                                <br />

                                            </>
                                            :
                                            <></>

                                    }

                                    <HStack>
                                        <FormControl isInvalid={errors.detalle && touched.detalle}>
                                            <FormLabel>Detalle de su {values.tipo2 || "Proceso"} : (máximo 3000 caracteres)</FormLabel>
                                            <Textarea textColor={"blackAlpha.900"} variant={"filled"} type={'text'} size="lg" name={"detalle"} onChange={handleChange} onBlur={handleBlur} value={values.detalle} _focus={{ bg: "white", boxShadow: "none", borderColor: "inherit" }}  maxlength="3000" />
                                        </FormControl>
                                    </HStack>
                                    <br />

                                    <HStack>
                                        <FormControl isInvalid={errors.file && touched.file}>
                                            <FormLabel>Puede subir archivos (PNG, JPG, PDF con un máximo de 5MB ):</FormLabel>
                                            <Input
                                                textColor={"blackAlpha.900"}
                                                accept="image/*,application/pdf"
                                                variant={"filled"}
                                                type={'file'}
                                                size="lg"
                                                name={"file"}
                                                onChange={(event) =>
                                                    setFieldValue("file", event.currentTarget.files[0])
                                                }
                                            />
                                            <Box minHeight="50px"> <FormErrorMessage bgColor={"#F9E4E8"} textColor={"#000"}>{errors.file}</FormErrorMessage> </Box>
                                        </FormControl>

                                    </HStack>

                                    <br /><br />

                                    <legend>4. Medio elegido para recibir la respuesta:</legend>


                                    <HStack>
                                        <FormControl isInvalid={errors.envio && touched.envio}>
                                            <RadioGroup value={values.design} onChange={handleChange} spacing='24px' name="envio">
                                                <Field colorScheme="easycar1" as={Radio} value={"Correo electrónico"} >
                                                    Correo electrónico
                                                </Field>
                                                <br />
                                                <Field colorScheme="easycar1" as={Radio} value={"Entrega en Agencia"} >
                                                    Entrega en Agencia
                                                </Field>
                                            </RadioGroup>
                                        </FormControl>
                                    </HStack>
                                    <br />

                                    <Heading size={"md"}>INFORMACIÓN IMPORTANTE:</Heading>
                                    <Text>
                                        <br />
                                        · <b>Verifique</b> sus datos antes de <b>REGISTRAR</b> su reclamo/queja/pedido.
                                        <br />
                                        · Responderemos su reclamo / queja por escrito en un plazo máximo de <b>15 (QUINCE) días hábiles</b>, contados desde el día siguiente a la recepción del mismo.
                                        <br />
                                        · El procedimiento es <b>gratuito</b> y no puede condicionarse ni limitarse.
                                        <br />
                                        · No podremos atender su reclamo/queja/pedido si no se consignan los siguientes <b>datos mínimos:</b> nombre, documento de identidad, domicilio o correo electrónico, fecha del reclamo o queja y el detalle de los mismos.
                                        <br />
                                        · La formulación del reclamo <b>no impide</b> acudir a otras vías de solución de controversias ni es requisito previo para interponer una denuncia ante la Defensoría del Consumidor.
                                    </Text>

                                    <Button type="submit" mt={4} disabled={isSubmitting}>
                                        {isSubmitting ? <CircularProgress /> : 'Enviar'}
                                    </Button>
                                </form>
                            )}
                        </Formik>
                    </Box>
                }
            </Flex>

        </Layout >
    )
}

export default Reclamos